module.exports = __webpack_public_path__ + "static/media/aeroplane-air-travel.0ce4e597.jpg";